module.exports = __webpack_public_path__ + "fonts/OpenSans-Regular.woff";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Open_Sans/OpenSans-Regular.woff
// module id = 3483
// module chunks = 0